<template>
  <div>
    <section class="gc-donate">
      <h2 class="gc-donate__title">Thank you, <span>Chief!</span></h2>

      <div class="gc-donate__status" v-if="showDonationStatus">
        <div v-if="donationStatus.loading">
          <gc-loader class="gc-donate__loader"></gc-loader>
          <p>We are submitting your donation.</p>
        </div>

        <div v-else>
          <div v-if="donationStatus.success">
            <span class="gc-donate__icon gc-donate__icon--success">&check;</span>
            <p>Donation successfully submitted.</p>
            <div class="gc-donate__button-group">
              <button
                type="button"
                class="gc-donate__button gc-donate__button--cancel"
                @click="onCompleteSubmissionHandler"
              >
                Close
              </button>
            </div>

          </div>
          <div v-if="donationStatus.failed">
            <span class="gc-donate__icon gc-donate__icon--danger">&excl;</span>
            <p>Sorry, we could not complete your donation at this time.</p>
            <div class="gc-donate__button-group">
              <button
                type="button"
                class="gc-donate__button gc-donate__button--cancel"
                @click="onCancelSubmissionHandler"
              >
                Cancel
              </button>

              <button
                type="button"
                class="gc-donate__button"
                @click="onTryAgainHandler"
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>

      <form class="gc-donate__form">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSeqcA1nidRHDiwjLiOKU_IgVfzbymsGN2SsULvBF00Mn9iyBQ/viewform?embedded=true"
          width="100%" height="100%" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
      </form>

      <!-- <form class="gc-donate__form" @submit.prevent v-else>
        <section
          class="gc-donate__slide-card gc-donate__slide-card--first"
          :class="{
            'gc-donate__slide-card--slide-in-from-left': currentSlideStep == 5,
            'gc-donate__slide-card--slide-out-to-left': [2, 3, 4].includes(
              currentSlideStep
            ),
          }"
        >
          <div class="gc-donate__form-content">
            <h2 class="gc-donate__form-title">Donate a textbook</h2>
            <div class="gc-dictionary">
              <div class="gc-dictionary__word">
                <h2>Textbook</h2>
                <h3>/ˈtɛks(t)bʊk/</h3>
              </div>

              <div class="gc-dictionary__meaning">
                <h3>noun</h3>
                <blockquote>
                  a book used as a standard work for the study of a particular
                  subject.
                </blockquote>
              </div>
            </div>

            <div class="state-controls">
              <input
                type="text"
                class="state-controls__input"
                placeholder=" "
                id="book-title"
                required
                v-model="donation.title"
              />
              <label for="book-title" class="state-controls__label"
                >Textbook's Title*</label
              >
            </div>

            <div class="state-controls">
              <input
                type="text"
                class="state-controls__input"
                placeholder=" "
                id="book-author"
                required
                v-model="donation.authors"
              />
              <label for="book-authors" class="state-controls__label"
                >Textbook's Author(s)*</label
              >
            </div>

            <div class="state-controls">
              <select
                class="state-controls__input"
                v-model.number="donation.edition"
              >
                <option
                  id="book-edition"
                  v-for="edition in editions"
                  :value="edition.value"
                  v-text="edition.name"
                  :key="edition.value"
                ></option>
              </select>
              <label for="book-edition" class="state-controls__label"
                >Textbook's Edition</label
              >
            </div>

            <div class="gc-donate__form-step-bottons">
              <button data-direction="chief" @click="formButtonHandler">
                Continue
              </button>
            </div>
          </div>
        </section>

        <section
          class="gc-donate__slide-card gc-donate__slide-card--second"
          :class="{
            'gc-donate__slide-card--slide-in-from-left': currentSlideStep === 4,
            'gc-donate__slide-card--slide-out-to-left': currentSlideStep === 3,
          }"
        >
          <div class="gc-donate__form-content">
            <h2 class="gc-donate__form-title">
              Can we meet you chief?
              <span class="gc-donate__form-title-sub"
                >The details are strictly for fulfilments reminder.</span
              >
            </h2>

            <div class="gc-dictionary">
              <div class="gc-dictionary__word">
                <h2>Chief</h2>
                <h3>/tʃiːf/</h3>
              </div>

              <div class="gc-dictionary__meaning">
                <h3>noun</h3>
                <blockquote>
                  a beautiful soul that donates books on GiveChief.
                </blockquote>
              </div>
            </div>

            <div class="state-controls">
              <input
                type="text"
                class="state-controls__input"
                placeholder=" "
                id="chief-name"
                name="name"
                required
                v-model="donation.name"
              />
              <label for="chief-name" class="state-controls__label"
                >Your full name please?</label
              >
            </div>

            <div class="state-controls">
              <input
                type="email"
                class="state-controls__input"
                placeholder=" "
                id="chief-email"
                v-model="donation.email"
                required
              />
              <label for="chief-name" class="state-controls__label"
                >Your email</label
              >
            </div>

            <div class="state-controls">
              <input
                type="phone"
                class="state-controls__input"
                placeholder=" "
                id="chief-phone"
                v-model="donation.phone"
                required
              />
              <label for="chief-phone" class="state-controls__label"
                >Finally, your phone number.</label
              >
            </div>

            <div class="gc-donate__form-step-bottons">
              <button
                type="button"
                class="
                  gc-donate__step-button gc-donate__step-button--back
                  col-1-of-3
                "
                data-direction="return-book"
                @click="formButtonHandler"
              >
                <gc-s-icon></gc-s-icon>
              </button>
              <button
                data-direction="hub"
                class="gc-donate__step-button col-2-of-3"
                @click="formButtonHandler"
              >
                Continue
              </button>
            </div>
          </div>
        </section>

        <section class="gc-donate__slide-card gc-donate__slide-card--third">
          <div class="gc-donate__form-content">
            <h2 class="gc-donate__form-title">Pick a Hub</h2>

            <div class="gc-dictionary">
              <div class="gc-dictionary__word">
                <h2>Hub</h2>
                <h3>/hʌb/</h3>
              </div>

              <div class="gc-dictionary__meaning">
                <h3>noun</h3>
                <blockquote>
                  a location where a chief can submit a promised donation.
                </blockquote>
              </div>
            </div>

            <div class="state-controls">
              <select
                class="state-controls__input"
                required
                v-model="donation.hub"
              >
                <option
                  id="hub"
                  v-for="hub in hubs"
                  :value="hub.id"
                  v-text="hub.name"
                  :key="hub.id"
                ></option>
              </select>
              <label for="hub" class="state-controls__label"
                >Prefered Hub</label
              >
            </div>

            <div class="gc-donate__form-step-bottons">
              <button
                type="button"
                class="
                  gc-donate__step-button gc-donate__step-button--back
                  col-1-of-3
                "
                @click="formButtonHandler"
                data-direction="return-chief"
              >
                <gc-s-icon></gc-s-icon>
              </button>
              <button
                type="submit"
                class="gc-donate__step-button col-2-of-3"
                @click="showDonationSummary"
              >
                Make Promise
              </button>
            </div>
          </div>
        </section>
      </form> -->
    </section>

    <gc-modal v-model="showSummaryModal" title="Confirm Donation">
      <summary-view
        :donation="donation"
        @onCancel="showSummaryModal = false"
        @onSubmit="onSubmitHandler"
      >
      </summary-view>
    </gc-modal>

    <footer class="gc-footer">
      <div class="gc-footer__content">
        <div class="row">
          <div class="col-1-of-3">
            <a class="link" href="/">
              <img
                src="../assets/images/logo-flat.svg"
                alt=""
                class="gc-footer__logo"
              />
            </a>
            <p class="gc-footer__note">
              GiveChief is dedicated to providing access to book to students
              from beautiful donors.
            </p>
          </div>

          <div class="col-1-of-3 u-align-text">
            <a
              class="link gc-footer__social-icon-link"
              href="https://www.instagram.com/givechief"
              target="_blank"
            >
              <img src="../assets/icons/instagram-icon.svg" alt="" />
            </a>

            <a
              class="link gc-footer__social-icon-link"
              href="https://medium.com/@givechief"
              target="_blank"
            >
              <img src="../assets/icons/medium-icon.svg" alt="" />
            </a>
          </div>

          <div class="col-1-of-3">
            <ul class="gc-footer__actions">
              <!-- <li><a class="link" href="">Policy</a></li>
              <li><a class="link" href="">Terms Of Use</a></li> -->
              <li>
                <router-link to="/" class="link"
                  >Created with ❤️ in 🇳🇬</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p class="gc-footer__copyright">GiveChief © {{(new Date()).getFullYear() }} </p>
    </footer>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/styles/mixins";

.gc-donate {
  max-width: 50rem;
  margin: auto;
  min-height: 80vh;
  padding: 2rem;

  &__title {
    font-size: 3rem;
    margin: 4rem 0;
    text-align: center;
    color: var(--color-secondary);

    span {
      font-weight: 700;
      color: var(--color-primary);
    }
  }

  &__form-title {
    text-align: center;
    font-size: 2.5rem;
    margin: 1.6rem 0;
    color: var(--color-black-tops);
  }

  &__form-title-sub {
    display: block;
    font-weight: 600;
    font-size: 1.3rem;
    color: var(--color-grey-black);
  }

  &__form {
    margin: 2rem 0;
    border-radius: 15px;
    position: relative;
    height: 135rem;
    overflow: hidden;
    box-shadow: 0 0.4rem 1.2rem rgb(22 30 46 / 16%);

    @include respond(phone) {
      height: 180rem;
    }
  }

  &__form-content {
    padding: 1.5rem 3rem 2.5rem;
    position: relative;
    height: 100%;

    & > * {
      margin-bottom: 2.5rem;
    }
  }

  &__slide-card {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: white;
    mix-blend-mode: normal;
    backdrop-filter: blur(10px);
    border-radius: 15px;
    box-shadow: 0 0.4rem 1.2rem rgb(22 30 46 / 16%);

    &--first {
      z-index: 3;
    }

    &--second {
      z-index: 2;
    }

    &--slide-out-to-left {
      animation: slideOutToLeft 0.3s linear;
      transform: translateX(-100%);
      animation-fill-mode: backwards;
    }

    &--slide-in-from-left {
      animation: slideInFromLeft 0.3s linear;
      transform: translateX(0);
      animation-fill-mode: backwards;
    }
  }

  &__form-step-bottons {
    margin-top: 4rem;
    position: absolute;
    bottom: 3rem;
    width: calc(100% - 6rem);

    .col-1-of-3 {
      width: 20%;
    }
    .col-2-of-3 {
      width: 75%;
      float: right;
    }

    & > * {
      display: inline;
    }
  }

  &__step-button {
    height: 6rem;

    &--back {
      padding: 1.8rem;
      background: transparent;
      border-color: var(--color-grey-trip);

      & svg {
        transform: rotate(180deg);
        fill: black;
      }
    }
  }

  &__status {
    margin: 2rem 0;
    border-radius: 15px;
    min-height: 40rem;
    padding: 2rem;
    overflow: hidden;
    box-shadow: 0 0.4rem 1.2rem rgb(22 30 46 / 16%);

    p {
      font-size: 2.4rem;
      color: var(--color-grey-dark);
      width: 14ch;
      margin: 2rem auto;
      text-align: center;
    }
  }

  &__loader {
    height: 5rem;
    width: 5rem;
    margin: 5rem auto;
  }

  &__button-group {
    margin: 4rem 0;
    text-align: center;
  }

  &__button {
    border: none;
    border-radius: 5px;
    padding: 1.2rem 3rem;
    font-size: 1.4rem;
    color: white;
    background: var(--color-secondary);
    font-weight: 600;
    text-transform: uppercase;
    cursor: pointer;
    box-shadow: 0 0.4rem 1.2rem rgb(22 30 46 / 16%);

    &--cancel {
      color: var(--color-text);
      background: white;
      margin-right: 2rem;
    }
  }

  &__icon {
    font-size: 7rem;
    text-align: center;
    display: block;

    &--success {
      color: var(--color-valid);
    }

    &--danger {
      color: var(--color-danger);
    }
  }
}

.gc-dictionary {
  &__word {
    color: var(--color-grey-trip);
    font-weight: 400;

    h2 {
      font-size: 2.8rem;
    }

    h3 {
      font-size: 1.5rem;
    }
  }

  &__meaning {
    font-weight: 400;
    line-height: 2rem;
    margin: 1.5rem 0;

    h3 {
      font-style: italic;
      color: var(--color-grey-shock);
      font-size: 1.6rem;
    }

    blockquote {
      padding-left: 2rem;
      font-size: 1.6rem;
      color: var(--color-grey-trip);

      span {
        display: inline-block;
      }
    }
  }
}
</style>

<script>
import { reactive, toRefs } from 'vue'
import summaryView from './summary.vue'
import api from '../service/api'

export default {
  components: { summaryView },
  setup () {
    const state = reactive({
      currentSlideStep: 1,
      donation: {
        title: '',
        authors: '',
        edition: 1,
        name: '',
        email: '',
        phone: '',
        hub: 'reco8yQhbGlGXEuh0',
        hubDetails: undefined
      },
      showSummaryModal: false,
      showDonationStatus: false,
      donationStatus: {
        loading: true,
        success: undefined,
        failed: undefined
      }
    })

    const editions = [
      { value: '1', name: '1st Edition' },
      { value: '2', name: '2nd Edition' },
      { value: '3', name: '3rd Edition' },
      { value: '4', name: '4th Edition' },
      { value: '5', name: '5th Edition' },
      { value: '6', name: '6th edition' },
      { value: '7', name: '7th edition' }
    ]

    const hubs = [
      { id: 'reco8yQhbGlGXEuh0', name: 'Mobolaji Bank-Anthony Junior High School' },
      { id: 'recO4eaI5zX76jFGe', name: 'Aje Comprehensive Junior High School' },
      { id: 'rectw61wEYn0Cs4GY', name: 'St. Agnes Primary School' },
      { id: 'recO1DntNPVQk0aeX', name: 'Lagos City Model Senior College, Yaba.' },
      { id: 'rec1Z8zSf1bbTz1lD', name: 'Ladi-Lak Institute Primary School, Alagomeji' }
    ]

    const createADonation = async function (donation) {
      try {
        state.donationStatus.loading = true
        state.donationStatus.success = false
        state.donationStatus.failed = false

        const newlyCreatedDonation = await api.post('donation', { donation })
        console.log(newlyCreatedDonation)
        state.donationStatus.success = true
      } catch (error) {
        state.donationStatus.failed = true
      } finally {
        state.donationStatus.loading = false
      }
    }

    const showDonationSummary = function () {
      state.donation.hubDetails = hubs.find(
        (hub) => hub.id === state.donation.hub
      )
      state.showSummaryModal = true
    }

    const checkFormValidity = function (step) {
      switch (step) {
        case 'chief': {
          return (data) => Boolean(data.title && data.authors && data.edition)
        }
        case 'hub': {
          return (data) => Boolean(data.name && data.phone && data.email)
        }
      }
    }

    const formButtonHandler = function (e) {
      const stepButtonAction = e.currentTarget.getAttribute('data-direction')
      switch (stepButtonAction) {
        case 'chief': {
          if (!checkFormValidity('chief')(state.donation)) return
          state.currentSlideStep = 2
          break
        }
        case 'hub': {
          if (!checkFormValidity('hub')(state.donation)) return
          state.currentSlideStep = 3
          break
        }
        case 'return-chief':
          state.currentSlideStep = 4
          break
        default: {
          state.currentSlideStep = 5
        }
      }
    }

    const onSubmitHandler = function () {
      state.showSummaryModal = false
      state.showDonationStatus = true

      const {
        title: Title,
        authors: Author,
        edition: Edition,
        name: Name,
        email: Email,
        phone: Phone,
        hubDetails
      } = state.donation

      const usersDonation = {
        Title,
        Author,
        Edition,
        Name,
        Email,
        Phone,
        Hub: [hubDetails.id]
      }

      createADonation(usersDonation)
    }

    const onTryAgainHandler = showDonationSummary

    const onCancelSubmissionHandler = function () {
      state.showDonationStatus = false
    }

    const resetDonationForm = function () {
      state.currentSlideStep = 1
      state.donation = {
        title: '',
        authors: '',
        edition: 1,
        name: '',
        email: '',
        phone: '',
        hub: 'reco8yQhbGlGXEuh0',
        hubDetails: undefined
      }
    }

    const onCompleteSubmissionHandler = function () {
      resetDonationForm()
      onCancelSubmissionHandler()
    }

    return {
      ...toRefs(state),
      editions,
      hubs,
      formButtonHandler,
      showDonationSummary,
      onSubmitHandler,
      onTryAgainHandler,
      onCancelSubmissionHandler,
      onCompleteSubmissionHandler
    }
  }
}
</script>
